import { memo, useMemo } from "react";

import { type FooterSectionSettings } from "@react/sections/Footer/Footer.data";
import {
  AVAILABLE_MARKETS,
  type MarketCountry,
  type MarketCurrency,
  type MarketLanguage,
  type MarketIsoCode,
} from "@root/tablescape/constants";
import { ObjectKeys } from "@root/tablescape/utilities";
import { DrawerProvider } from "@sections/DrawerProvider";
import { CountrySelectorView } from "@sections/DrawerProvider/CountrySelector/CountrySelector.view";
import { GlobalDrawer } from "@tablescape/state";

export type Localization = {
  country: MarketCountry;
  currency: MarketCurrency;
  domain: string;
  isoCode: MarketIsoCode;
  language: MarketLanguage;
};

const CountrySelectorBase = ({
  isoCode = "US",
  text,
}: {
  isoCode: MarketIsoCode;
  text: FooterSectionSettings["countrySelector"]["text"];
}) => {
  const localization = AVAILABLE_MARKETS[isoCode];
  const localizationOptions = useMemo(
    () =>
      ObjectKeys(AVAILABLE_MARKETS).map((isoCode: MarketIsoCode) => {
        return AVAILABLE_MARKETS[isoCode];
      }),
    []
  );

  return (
    <DrawerProvider
      render={({ closeDrawer }) => (
        <CountrySelectorView
          closeSelector={closeDrawer}
          localization={localization}
          localizationOptions={localizationOptions}
          text={text}
        />
      )}
      target={GlobalDrawer.COUNTRY_SELECTOR}
    />
  );
};

export const CountrySelector = memo(CountrySelectorBase);
